export enum FeatureType {
  DataSource = <any> 'DataSource',
  Feature = <any> 'Feature',
  Record = <any> 'Record'
}

export enum FeatureFormat {
  GeoJSON,
  JSON
}

export enum SourceFeatureType {
  Query = <any> 'Query',
  Search = <any> 'Search',
  Click = <any> 'Click',
  LocateXY = <any> 'LocateXY'
}
